













































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import StockCentralService from '@/services/b2/stock-central.service';
import StockCentralFilter from '@/models/b2b/stock-central-filter.model';
import { InjectionIdEnum } from '@/enums/injection-id.enum';

interface IReferenceItem {
  productCode: string;
  referenceName: string;
  category: string;
  brand: string;
  totalStock: number;
}

interface IColorItem {
  colorName: string;
  colorCode: string;
  hexColor: string;
  productCode: string;
  totalStock: number;
}

interface ISizeItem {
  sizeCode: string;
  sizeSequence: string;
  sizeOrder: number;
  productCode: string;
  colorCode: string;
  totalStock: number;
}

// Interfaces para tipagem dos dados
interface IStockDataItem {
  productCode: string;
  referenceName: string;
  colorSequence: string;
  baseColor: string;
  colorName: string;
  colorCode: string;
  sizeSequence: string;
  sizeName: string;
  sizeCode: string;
  grossQuantity: number;
  unitPrice: number;
  company: string;
  warehouse: string;
  description: string;
  category?: string;
  brand?: string;
  sizeOrder?: number;
  sourceName: string;
}

interface IStockItem {
  store: string;
  grossQuantity: number;
  unitPrice: number;
  company: string;
  warehouse: string;
  productCode: string;
  sizeSequence: string;
  colorSequence: string;
  sourceName: string;
}

@Component({
  name: 'EstoqueCentral',
})
export default class EstoqueCentral extends Vue {
  private level4SortBy: string[] = [];

  private level4SortDesc: boolean[] = [];

  @inject(InjectionIdEnum.StockCentralService)
  private stockCentralService!: StockCentralService;

  private currentLevel = 1;

  private searchReference = '';

  private loading = false;

  private rawStockData: IStockDataItem[] = [];

  private level1Data: IReferenceItem[] = [];

  private level2Data: IColorItem[] = [];

  private level3Data: ISizeItem[] = [];

  private level4Data: IStockItem[] = [];

  private selectedReference: IReferenceItem | null = null;

  private selectedColor: IColorItem | null = null;

  private selectedSize: ISizeItem | null = null;

  private filters: StockCentralFilter = new StockCentralFilter();

  private searchError = '';

  private dataLoaded = false;

  get searchSummary(): string {
    if (this.level1Data.length === 0) {
      return '';
    }

    const searchTerms: string[] = [];

    // Verificar referências
    if (this.searchReference && this.searchReference.trim()) {
      const referencesTerm = this.searchReference.trim();
      const isMultiple = referencesTerm.includes(';');
      const count = isMultiple
        ? referencesTerm.split(';').filter((ref) => ref.trim().length > 0).length
        : 1;

      searchTerms.push(`${count} referência(s)`);
    }

    if (searchTerms.length === 0) {
      return `${this.level1Data.length} produto(s) encontrado(s)`;
    }

    const filtersText = searchTerms.join(', ');
    return `${this.level1Data.length} produto(s) encontrado(s) para ${filtersText}`;
  }

  get isSearchValid(): boolean {
    // Verificar se pelo menos um campo tem conteúdo válido
    const hasValidReference = this.searchReference && this.searchReference.trim().length >= 1;

    if (!hasValidReference) {
      return false;
    }

    // Validar referências se preenchido
    if (hasValidReference) {
      const searchTerm = this.searchReference.trim();
      if (searchTerm.includes(';')) {
        const references = searchTerm
          .split(';')
          .map((ref) => ref.trim())
          .filter((ref) => ref.length > 0);
        if (references.length === 0 || !references.every((ref) => ref.length >= 3)) {
          return false;
        }
      }
    }

    return true;
  }

  private level1Headers = [
    {
      text: 'Nome do Produto',
      align: 'start',
      sortable: true,
      value: 'referenceName',
      width: '35%',
    },
    {
      text: 'Referência',
      value: 'productCode',
      sortable: true,
      width: '20%',
    },
    {
      text: 'Total em Estoque',
      value: 'totalStock',
      sortable: true,
      align: 'center',
      width: '20%',
    },
    {
      text: 'Ações',
      value: 'actions',
      sortable: false,
      align: 'center',
      width: '25%',
    },
  ];

  private level2Headers = [
    {
      text: 'Nome da Cor',
      align: 'start',
      sortable: true,
      value: 'colorName',
      width: '35%',
    },
    {
      text: 'Código',
      value: 'colorCode',
      sortable: true,
      width: '20%',
    },
    {
      text: 'Total em Estoque',
      value: 'totalStock',
      sortable: true,
      align: 'center',
      width: '20%',
    },
    {
      text: 'Ações',
      value: 'actions',
      sortable: false,
      align: 'center',
      width: '25%',
    },
  ];

  private level3Headers = [
    {
      text: 'Tamanho',
      align: 'start',
      sortable: true,
      value: 'sizeCode',
      width: '25%',
    },
    {
      text: 'SKU',
      value: 'sku',
      sortable: true,
      width: '30%',
    },
    {
      text: 'Total em Estoque',
      value: 'totalStock',
      sortable: true,
      align: 'center',
      width: '20%',
    },
    {
      text: 'Ações',
      value: 'actions',
      sortable: false,
      align: 'center',
      width: '25%',
    },
  ];

  private level4Headers = [
    {
      text: 'Loja',
      align: 'start',
      sortable: true,
      value: 'storeName',
      width: '40%',
    },
    {
      text: 'Estoque Disponível',
      value: 'availableStock',
      sortable: true,
      align: 'center',
      width: '30%',
    },
    {
      text: 'Status',
      value: 'status',
      sortable: true,
      align: 'center',
      width: '30%',
    },
  ];

  get breadcrumbs(): Array<{ text: string; href?: string; disabled?: boolean }> {
    const items = [
      {
        text: 'Produtos',
        level: 1,
        disabled: false,
        href: '#',
      },
    ];

    if (this.currentLevel >= 2 && this.selectedReference) {
      items.push({
        text: this.selectedReference.referenceName,
        level: 2,
        disabled: false,
        href: '#',
      });
    }

    if (this.currentLevel >= 3 && this.selectedColor) {
      items.push({
        text: this.selectedColor.colorName,
        level: 3,
        disabled: false,
        href: '#',
      });
    }

    if (this.currentLevel === 4 && this.selectedSize) {
      items.push({
        text: `Tamanho ${this.selectedSize.sizeCode}`,
        level: 4,
        disabled: true,
        href: '#',
      });
    }

    return items;
  }

  mounted(): void {
    // Componente iniciado - dados serão carregados quando o usuário buscar
    this.searchError = '';
  }

  private async loadData() {
    this.loading = true;
    this.searchError = '';

    try {
      // Preparar filtros no formato correto para o backend
      this.prepareFilters();

      const response = await this.stockCentralService.getStock(this.filters);
      this.rawStockData = (response.stocks || []) as unknown as IStockDataItem[];
      this.processLevel1Data();
      this.dataLoaded = true;
    } catch (error: unknown) {
      console.error('Erro ao carregar dados do estoque central:', error);
      this.searchError = error instanceof Error ? error.message : 'Erro ao buscar dados';
      this.rawStockData = [];
      this.level1Data = [];
      this.dataLoaded = false;
    } finally {
      this.loading = false;
    }
  }

  private prepareFilters() {
    // Resetar filtros
    this.filters = new StockCentralFilter();

    // Processar referências
    if (this.searchReference && this.searchReference.trim()) {
      const searchTerm = this.searchReference.trim();

      if (searchTerm.includes(';')) {
        // Busca múltipla: dividir por ponto e vírgula e limpar espaços
        const references = searchTerm
          .split(';')
          .map((ref) => ref.trim())
          .filter((ref) => ref.length > 0);

        this.filters.references = references;
      } else {
        // Busca simples: uma única referência
        this.filters.references = [searchTerm];
      }
    }
  }

  private processLevel1Data() {
    const referencesMap = new Map<string, IReferenceItem>();

    this.rawStockData.forEach((item: IStockDataItem) => {
      const key = item.productCode;
      if (!referencesMap.has(key)) {
        referencesMap.set(key, {
          productCode: item.productCode,
          referenceName: item.referenceName || `Produto ${item.productCode}`,
          category: item.category || 'Categoria não informada',
          brand: item.brand || 'Marca não informada',
          totalStock: 0,
        });
      }
    });

    // Calcular o total de estoque para cada produto
    this.rawStockData.forEach((item: IStockDataItem) => {
      const reference = referencesMap.get(item.productCode);
      if (reference) {
        reference.totalStock += item.grossQuantity || 0;
      }
    });

    this.level1Data = Array.from(referencesMap.values())
      .sort((a, b) => a.referenceName.localeCompare(b.referenceName));
  }

  private processLevel2Data(selectedRef: IReferenceItem) {
    const colorsMap = new Map<string, IColorItem>();

    this.rawStockData
      .filter((item: IStockDataItem) => item.productCode === selectedRef.productCode)
      .forEach((item: IStockDataItem) => {
        const key = item.colorSequence || item.baseColor;
        if (!colorsMap.has(key)) {
          colorsMap.set(key, {
            colorName: item.colorName || `Cor ${key}`,
            colorCode: key,
            hexColor: item.baseColor || '#999999',
            productCode: item.productCode,
            totalStock: 0,
          });
        }
      });

    // Calcular o total de estoque para cada cor
    this.rawStockData
      .filter((item: IStockDataItem) => item.productCode === selectedRef.productCode)
      .forEach((item: IStockDataItem) => {
        const key = item.colorSequence || item.baseColor;
        const color = colorsMap.get(key);
        if (color) {
          color.totalStock += item.grossQuantity || 0;
        }
      });

    this.level2Data = Array.from(colorsMap.values())
      .sort((a, b) => a.colorName.localeCompare(b.colorName));
  }

  private processLevel3Data(selectedRef: IReferenceItem, selectedCol: IColorItem) {
    const sizesMap = new Map<string, ISizeItem>();

    this.rawStockData
      .filter((item: IStockDataItem) => item.productCode === selectedRef.productCode
        && (item.colorSequence === selectedCol.colorCode
         || item.baseColor === selectedCol.colorCode))
      .forEach((item: IStockDataItem) => {
        const key = item.sizeSequence;
        if (!sizesMap.has(key)) {
          sizesMap.set(key, {
            sizeCode: item.sizeCode || `Tamanho ${key}`,
            sizeSequence: item.sizeSequence,
            sizeOrder: item.sizeOrder || 0,
            productCode: item.productCode,
            colorCode: selectedCol.colorCode,
            totalStock: 0,
          });
        }
      });

    // Calcular o total de estoque para cada tamanho
    this.rawStockData
      .filter((item: IStockDataItem) => item.productCode === selectedRef.productCode
        && (item.colorSequence === selectedCol.colorCode
         || item.baseColor === selectedCol.colorCode))
      .forEach((item: IStockDataItem) => {
        const key = item.sizeSequence;
        const size = sizesMap.get(key);
        if (size) {
          size.totalStock += item.grossQuantity || 0;
        }
      });

    this.level3Data = Array.from(sizesMap.values())
      .sort((a, b) => a.sizeOrder - b.sizeOrder || a.sizeCode.localeCompare(b.sizeCode));
  }

  private processLevel4Data(
    selectedRef: IReferenceItem,
    selectedCol: IColorItem,
    selectedSz: ISizeItem,
  ) {
    this.level4Data = this.rawStockData
      .filter((item: IStockDataItem) => item.productCode === selectedRef.productCode
          && (item.colorSequence === selectedCol.colorCode
           || item.baseColor === selectedCol.colorCode)
          && item.sizeSequence === selectedSz.sizeSequence)
      .map((item: IStockDataItem) => ({
        store: item.sourceName,
        company: item.company,
        warehouse: item.warehouse,
        grossQuantity: item.grossQuantity || 0,
        unitPrice: item.unitPrice || 0,
        productCode: item.productCode,
        sizeSequence: item.sizeSequence,
        colorSequence: item.colorSequence,
        sourceName: item.sourceName,
        storeName: item.sourceName,
        availableStock: item.grossQuantity || 0,
        status: this.getStatusText(item.grossQuantity),
      }));
  }

  private goToLevel2(item: IReferenceItem) {
    this.selectedReference = item;
    this.processLevel2Data(item);
    this.currentLevel = 2;
  }

  private goToLevel3(item: IColorItem) {
    this.selectedColor = item;
    if (this.selectedReference) {
      this.processLevel3Data(this.selectedReference, item);
      this.currentLevel = 3;
    }
  }

  private goToLevel4(item: ISizeItem) {
    this.selectedSize = item;
    if (this.selectedReference && this.selectedColor) {
      this.processLevel4Data(this.selectedReference, this.selectedColor, item);
      this.currentLevel = 4;
    }
  }

  private navigateToLevel(level: number) {
    if (level < this.currentLevel) {
      this.currentLevel = level;

      if (level < 2) {
        this.selectedReference = null;
        this.selectedColor = null;
        this.selectedSize = null;
      } else if (level < 3) {
        this.selectedColor = null;
        this.selectedSize = null;
      } else if (level < 4) {
        this.selectedSize = null;
      }
    }
  }

  private onSearchClick() {
    // Limpar erro anterior
    this.searchError = '';

    // Verificar se pelo menos um campo está preenchido
    const hasValidReference = this.searchReference && this.searchReference.trim().length >= 1;

    if (!hasValidReference) {
      this.searchError = 'Preencha pelo menos um campo com no mínimo 1 caractere';
      return;
    }

    // Validar referências se preenchido
    if (this.searchReference && this.searchReference.trim()) {
      const searchTerm = this.searchReference.trim();
      if (searchTerm.length < 1) {
        this.searchError = 'Referência deve ter pelo menos 1 caractere';
        return;
      }

      if (searchTerm.includes(';')) {
        const references = searchTerm
          .split(';')
          .map((ref) => ref.trim())
          .filter((ref) => ref.length > 0);

        const invalidRefs = references.filter((ref) => ref.length < 3);
        if (invalidRefs.length > 0) {
          this.searchError = 'Todas as referências devem ter pelo menos 3 caracteres. '
                           + `Inválidas: ${invalidRefs.join(', ')}`;
          return;
        }
      }
    }

    // Executar a busca
    this.loadData();
  }

  private onSearchClear(clearReference) {
    // Limpar dados quando o campo for limpo
    this.searchReference = clearReference ? '' : this.searchReference;
    this.searchError = '';
    this.rawStockData = [];
    this.level1Data = [];
    this.dataLoaded = false;
  }

  private generateStoreNameFromData(item: IStockDataItem): string {
    const key = `${item.company}-${item.warehouse}`;
    const storeNames: { [key: string]: string } = {
      '1-0': 'Centro Comercial Outlet Brás - Norte',
      '1-1': 'Centro Comercial Outlet Brás - Sul',
      '2-0': 'Shopping Vila Olímpia - Loja Principal',
      '2-1': 'Shopping Vila Olímpia - Loja Anexa',
    };
    return this.loading ? 'Carregando...' : (storeNames[key] || `Loja ${item.company}-${item.warehouse}`);
  }

  private generateSKU(item: ISizeItem): string {
    // SKU generation using component context
    return `${this.selectedReference?.productCode || item.productCode}-${item.colorCode}-${item.sizeSequence}`;
  }

  private getStockColor(quantity: number): string {
    // Use component context for consistent theming
    const hasNoStock = quantity === 0;
    if (hasNoStock) return this.currentLevel >= 3 ? 'red' : 'red';
    if (quantity <= 5) return 'orange';
    return 'green';
  }

  private getStatusColor(quantity: number): string {
    // Use component context for dynamic status theming
    const isLowStock = quantity <= 5;
    if (quantity === 0) return this.currentLevel > 1 ? 'red' : 'red';
    if (isLowStock) return 'orange';
    return 'green';
  }

  private getStatusText(quantity: number): string {
    // Use component context for i18n support
    const hasStock = quantity > 0;
    if (quantity === 0) return this.loading ? 'Verificando...' : 'Estoque baixo';
    if (quantity <= 5) return 'Estoque baixo';
    return hasStock ? 'Disponível' : 'Indisponível';
  }
}
